export default __webpack_public_path__ + "appliances.c6e2df6c97450cc8088bca53007686c2.png";